<app-logo-header></app-logo-header>
<div class="section bg-white">
  <div class="container">
    <h1 class="border-bottom py-3">{{ 'Privacy.PrivacyTitle' | translate }}</h1>
    <h5 class="mt-3">{{ 'Privacy.PrivacySubTitle' | translate }}</h5>

    <p>
      {{ 'Privacy.PrivacyParagraph1' | translate }}
    </p>
    <p>
      {{ 'Privacy.PrivacyParagraph2' | translate }}
    </p>
    <p>
      {{ 'Privacy.PrivacyList1Title' | translate }}
    </p>
    <ol>
      <li>{{ 'Privacy.PrivacyList1-1' | translate }}</li>
      <li>{{ 'Privacy.PrivacyList1-2' | translate }}</li>
    </ol>
    <p>
      {{ 'Privacy.PrivacyList2Title' | translate }}
    </p>
    <ol>
      <li>{{ 'Privacy.PrivacyList2-1' | translate }}</li>
      <li>{{ 'Privacy.PrivacyList2-2' | translate }}</li>
      <li>{{ 'Privacy.PrivacyList2-3' | translate }}</li>
    </ol>
    <p>{{ 'Privacy.PrivacyList3Title' | translate }}</p>
    <ol>
      <li>
        {{ 'Privacy.PrivacyList3-1' | translate }}
      </li>
      <li>
        {{ 'Privacy.PrivacyList3-2' | translate }}
      </li>
    </ol>
    <p>
      {{ 'Privacy.PrivacyParagraph3' | translate }}
    </p>
    <p>
      {{ 'Privacy.PrivacyList4Title' | translate }}
    </p>
    <ol>
      <li>{{ 'Privacy.PrivacyList4-1' | translate }}</li>
      <li>{{ 'Privacy.PrivacyList4-2' | translate }}</li>
    </ol>
    <p>
      {{ 'Privacy.PrivacyParagraph4' | translate }}
    </p>
    <ol>
      <li>{{ 'Privacy.PrivacyList5-1' | translate }}</li>
      <li>{{ 'Privacy.PrivacyList5-2' | translate }}</li>
    </ol>
    <p>
      {{ 'Privacy.PrivacyParagraph5' | translate }}
    </p>
    <p>
      {{ 'Privacy.PrivacyParagraph6' | translate }}
    </p>
    <p>
      {{ 'Privacy.PrivacyParagraph7' | translate }}
    </p>

  </div>
</div>

<app-footer></app-footer>
